"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var constants_1 = require("./constants");
var palettes_1 = require("./palettes");
var scales_1 = require("./scales");
tslib_1.__exportStar(require("./constants"), exports);
tslib_1.__exportStar(require("./palettes"), exports);
tslib_1.__exportStar(require("./scales"), exports);
tslib_1.__exportStar(require("./transparency"), exports);
exports.default = {
    NTDarkGrey: scales_1.NTDarkGrey,
    NTGreen: scales_1.NTGreen,
    NTGold: scales_1.NTGold,
    NTWarmGrey: scales_1.NTWarmGrey,
    darkGreen: scales_1.DarkGreen,
    green: scales_1.Green,
    lightGreen: scales_1.LightGreen,
    yellow: scales_1.Yellow,
    darkBlue: scales_1.DarkBlue,
    aqua: scales_1.Aqua,
    teal: scales_1.Teal,
    purple: scales_1.Purple,
    red: scales_1.Red,
    orange: scales_1.Orange,
    black: constants_1.black,
    white: constants_1.white,
    transparent: constants_1.transparent,
    fadedBlue: constants_1.fadedBlue,
    fadedGreen: constants_1.fadedGreen,
    fadedLightGreen: constants_1.fadedLightGreen,
    fadedPurple: constants_1.fadedPurple,
    fadedOrange: constants_1.fadedOrange,
    elementDivider: constants_1.uniqueGrey,
    primary: palettes_1.primary,
    secondary: palettes_1.secondary,
    text: palettes_1.text,
    panel: palettes_1.panel,
    button: palettes_1.button,
    positiveGreen: constants_1.positiveGreen,
    negativeRed: constants_1.negativeRed,
    darkPositiveGreen: constants_1.darkPositiveGreen,
    darkNegativeRed: constants_1.darkNegativeRed,
    datePicker: palettes_1.datePicker,
};
